import { defineChain, numberToHex } from "viem";

export const ROBINHOOD_CHAIN_ID = 4663;
export const ROBINHOOD_RPC_URL = "https://rpc.mainnet.chain.robinhood.com";
export const ROBINHOOD_EXPLORER_URL = "https://robinhoodchain.blockscout.com";

/**
 * Robinhood Chain, an Arbitrum Orbit L3. Values come from /api/config at
 * runtime; these are the defaults used before config resolves.
 */
export function robinhoodChain(
  rpcUrl: string = ROBINHOOD_RPC_URL,
  explorerUrl: string = ROBINHOOD_EXPLORER_URL,
  chainId: number = ROBINHOOD_CHAIN_ID,
) {
  return defineChain({
    id: chainId,
    name: "Robinhood Chain",
    nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
    rpcUrls: { default: { http: [rpcUrl] } },
    blockExplorers: { default: { name: "Blockscout", url: explorerUrl } },
  });
}

/** Payload for wallet_addEthereumChain. */
export function addChainParams(chainId: number, rpcUrl: string, explorerUrl: string) {
  return {
    chainId: numberToHex(chainId),
    chainName: "Robinhood Chain",
    nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
    rpcUrls: [rpcUrl],
    blockExplorerUrls: [explorerUrl],
  };
}

export const txUrl = (explorerUrl: string, hash: string): string =>
  `${explorerUrl.replace(/\/$/, "")}/tx/${hash}`;

export const addressUrl = (explorerUrl: string, address: string): string =>
  `${explorerUrl.replace(/\/$/, "")}/address/${address}`;
